export class LookupsModel {
  aciklama: string;
  kod: number;
  ozelKod: string;

  constructor(item?: LookupsModel) {
    this.aciklama = item?.aciklama || '';
    this.kod = item?.kod || null;
    this.ozelKod = item?.ozelKod || '';
  }
}
